/*
 *  Каждое слово в инпуте после пробела или тире с начинается с большой буквы
 */
export const everyWordToUpperCase = (value: string): string =>
    value.toLowerCase().replace(/(^|\s|-)\S/g, line => line.toUpperCase());
